<template>
  <div class="flex_1 margin_horizontal">
    <AccessRestrictedTabs
      class="table_tabs"
      v-model="activeTab"
      :elements="realTabTypes"
      :session-key="$route.path"
    />
    <DebtorContractsTable v-if="isDebtor"></DebtorContractsTable>
    <template v-else>
      <ContractsTable v-if="activeTab === realTabTypes.contracts" />
      <SettledTable v-if="activeTab === realTabTypes.settled" />
    </template>
  </div>
</template>
<script>
import ContractsTable from "src/components/templates/trackPay/ContractsTable";
import SettledTable from "src/components/templates/trackPay/SettledTable";
import AccessRestrictedTabs from "@/components/templates/common/permissions/AccessRestrictedTabs";
import {enumDef} from "@/common/enumDefs";
import {navigationTabs} from "@/common/navigation/navigationTabs";

import DebtorContractsTable from "src/components/templates/trackPay/debtor/DebtorContractsTable";

export default {
  components: {
    AccessRestrictedTabs,
    ContractsTable,
    SettledTable,
    DebtorContractsTable,
  },
  data() {
    let tabTypes = {
      contracts: {
        name: navigationTabs.seller.trackPay.contracts,
        translationKey: "trackPay.tabs.contracts",
				permission: enumDef.permissions.SellerTrackAndPay
      },
      settled: {
        name: navigationTabs.seller.trackPay.settled,
        translationKey: "trackPay.tabs.settled",
				permission: enumDef.permissions.SellerTrackAndPay,
      },
    };

    return {
      tabTypes: tabTypes,
      activeTab: null,
    };
  },
  mounted() {
    if (this.isDebtor) {
      this.tabTypes = {
        contracts: {
          name: navigationTabs.debtor.trackPay.contracts,
          translationKey: "trackPay.tabs.contracts",
        },
      };
    }
  },
  computed: {
    isDebtor() {
      return this.$route.path === "/debtor/trackPay"
    },
    realTabTypes() {
      let tabTypes = {
        contracts: {
          name: navigationTabs.seller.trackPay.contracts,
          translationKey: "trackPay.tabs.contracts",
				  permission: enumDef.permissions.SellerTrackAndPay,
        },
        settled: {
          name: navigationTabs.seller.trackPay.settled,
          translationKey: "trackPay.tabs.settled",
				  permission: enumDef.permissions.SellerTrackAndPay,
        },
      };
      if (this.isDebtor) {
        tabTypes = {
          contracts: {
            name: navigationTabs.debtor.trackPay.contracts,
            translationKey: "trackPay.tabs.contracts",
          },
        };
      }
      return tabTypes;
    },
  },
};
</script>
